import { ReactElement, useEffect } from "react";
import { useMatch, useNavigate } from "react-router";
import { List, ListElement } from "../../../components";
import { useDashboardContext } from "../../../components/dashboard/Dashboard.shared";
import { NavigationBarMenu } from "../../../components/navigation/NavigationBar";
import { DELIVERY_METHOD_CHARGES } from "../../../constants/routes";
import { ORDER_FULFILLMENT_TYPES } from "../../../constants/sellarConstants.shared";
import styles from "./DeliveryTiers.module.css";

export const DeliveryTiers = (): ReactElement => {
  const navigate = useNavigate();
  const method = useMatch(DELIVERY_METHOD_CHARGES.pattern)?.params.method;

  const { isTwoPanel } = useDashboardContext();

  useEffect(() => {
    if (!method && isTwoPanel) {
      navigate(DELIVERY_METHOD_CHARGES.href({ method: "direct" }));
    }
  }, [method, isTwoPanel, navigate]);
  return (
    <>
      <NavigationBarMenu title={"Delivery Tiers"} />
      <List>
        {Object.values(ORDER_FULFILLMENT_TYPES)
          .filter((i) => ["courier", "direct", "haulier"].includes(i.value))
          .map((i) => (
            <ListElement
              promptText={""}
              key={i.value}
              to={DELIVERY_METHOD_CHARGES.href({ method: i.value })}
              selected={i.value === method}
            >
              <div className={styles.content}>
                <div className={styles.priceTierName}>
                  <b>{i.name}</b>
                </div>
              </div>
            </ListElement>
          ))}
      </List>
    </>
  );
};
